export const styles = {
  // Empty State
  emptyStateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40vh',
  },

  // Main Container
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  // Total Margin Summary
  marginSummaryPaper: (theme) => ({
    px: 2,
    py: 0.75,
    mb: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    bgcolor:
      theme.palette.mode === 'dark'
        ? 'background.paper'
        : theme.palette.grey[100],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
  }),
  marginSummaryBoxLeft: { flex: 1, minWidth: 0, pr: 1 },
  marginSummaryBoxRight: { flex: 1, minWidth: 0, textAlign: 'right', pl: 1 },
  marginSummaryLabel: {
    fontSize: { xs: '0.65rem', sm: '0.75rem' },
    display: 'block',
    lineHeight: 1,
    mb: 0.5,
  },
  marginSummaryValue: {
    fontSize: { xs: '0.75rem', sm: '0.875rem' },
    wordBreak: 'break-all',
    lineHeight: 1.2,
  },

  // Lists and Tables
  mobileListContainer: {
    flex: 1,
    overflow: 'auto',
    p: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  desktopTableContainer: { flex: 1, overflow: 'auto', borderRadius: 0 },
  tableHeaderCell: { whiteSpace: 'nowrap' },
};
